export default __webpack_public_path__ + "static/media/AC_7.94f27aae.jpg";